module.exports = __webpack_public_path__ + "static/media/recentFeedNormalTravel.dba24844.svg";